<template>
    <div>
        <!-- Validation -->
        <div class="input--invalid" v-if="showPauseAnswerIdRequiredValidationMessage">
            <p class="input__message" v-text="$t('PAUSE_DELIVERIES_PLEASE_CHOOSE')"></p>
        </div>

        <h2 class="pause--heading" v-text="$t('PAUSE_DELIVERIES_BEFORE_WE',{username: this.user.first_name})"></h2>

        <form method="post" class="pause-reasons">
            <div class="input__radio pause-reasons--item" v-for="answer in this.surveyAnswers" v-bind:key="answer.id">
                <input
                    class="input__radio-item"
                    :id="`${subscriptionId}:${answer.id}`"
                    v-model="pauseAnswerId"
                    type="radio"
                    :name="subscriptionId"
                    :value="answer.id"/>
                <label
                    :for="`${subscriptionId}:${answer.id}`"
                    class="input__radio-label"
                    v-text="answer.label">
                </label>
            </div>
        </form>
        <confirmation-step
            v-if="pauseSurveyAnswer && pauseAnswerId === 8"
            :subscriptionId="subscriptionId"
            :pauseSurveyAnswer="pauseSurveyAnswer"
            @deliveries-paused="handleDeliveriesPaused"/>
        <button
            v-if="pauseAnswerId !== 8"
            @click.prevent="pauseReasonSelected"
            class="btn btn--primary btn--full-width pause-next--button"
            v-text="nextStepButtonLabel">
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import required from 'vuelidate/src/validators/required';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import { pauseSubscription } from '@/helpers/GAHelpers';
import { ConfirmationStep } from '@/components/partials/account/my-delivery-schedule/manage-delivery/pauseSteps/index.js';

export default {
    name: 'PauseReason',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
    },
    components: {
        ConfirmationStep,
    },
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
            pauseAnswerId: null,
            pauseSurveyAnswer: null,
            isNextStepClicked: false,
            surveyAnswers: null,
            pauseReasons: [],
        };
    },
    computed: {
        ...mapGetters({
            user: 'account/getUser',
            isUSA: 'localisation/isUSA',
        }),
        nextStepButtonLabel() {
            if (this.isUSA) return this.$t('PAUSE_DELIVERIES_SELECT_REASON');
            else return this.pauseSurveyAnswer ? this.$t('PAUSE_DELIVERIES_NEXT_STEP') : this.$t('PAUSE_DELIVERIES_SELECT_REASON');
        },
        showPauseAnswerIdRequiredValidationMessage() {
            return this.isNextStepClicked && this.pauseAnswerId === null && !this.$v.pauseAnswerId.required;
        },
    },
    mounted() {
        this.setPauseReasons();
    },
    validations: {
        pauseAnswerId: {
            required,
        },
    },
    watch: {
        pauseAnswerId(answerId) {
            this.pauseSurveyAnswer = this.surveyAnswers.find(answer => answer.id === answerId);
        },
    },
    methods: {
        pauseReasonSelected() {
            let stepAttempt = this.pauseSurveyAnswer?.nextSteps[0];
            let pauseReason = this.pauseSurveyAnswer?.label;
            process.env.VUE_APP_ENABLE_TRACKING === 'true' && pauseSubscription(stepAttempt, pauseReason);
            this.$emit('input', this.pauseSurveyAnswer);
        },
        handlingIndexForUsa(arr) {
            let currentIndex;
            if (this.isUSA) {
                return currentIndex = arr.length - 2;
            } else {
                return currentIndex = arr.length - 1;
            }
        },
        shuffle(arr) {
            let currentIndex = this.handlingIndexForUsa(arr);
            let randomIndex;
            while (currentIndex !== 0) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;
                [arr[currentIndex], arr[randomIndex]] = [arr[randomIndex], arr[currentIndex]];
            }
            return arr;
        },
        async setPauseReasons() {
            const reasons = await require(`@/content/${process.env.VUE_APP_COUNTRY_ISO}/${process.env.VUE_APP_I18N_LOCALE}/pauseDeliveriesSurveyAnswers.json`);
            this.surveyAnswers = this.shuffle(reasons.items);
        },
        handleDeliveriesPaused() {
            this.$emit('deliveries-paused');
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-reasons{
        padding-bottom: 20px;
    }
    .pause-reasons--item {
        margin: 8px 0;
    }
    .pause-next--button {
        margin-bottom: 5px;
    }
</style>
